import * as React from 'react';
import { Fragment } from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler, TableColumn } from 'logic/reports/ReportSettings';
import { ReportType } from 'types';
import { ColumnPositionControlList } from './ColumnPositionControlList';
import { ColumnGroupControlList } from './ColumnGroupControlList';
import { ColumnSortControlList } from './ColumnSortControlList';
import { TablePreview } from './TablePreview';

import './TableLayoutSection.css';

export type OwnProps = {
    reportType: ReportType;
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};


type Props = OwnProps & RecomposeProps & TranslateProps;

const RawTableLayoutSection = ({ reportType, reportSettings, handleColumnsChanged, t }: Props) =>
    <Fragment>
        <div className="table-layout-options">
            <div>
                <h3>
                    { t('6.9622.3858') }
                </h3>
                <div>
                    <ColumnPositionControlList
                        reportType={ reportType }
                        columns={ reportSettings.tableColumns }
                        onChange={ handleColumnsChanged }
                    />
                </div>
            </div>
            <div>
                <h3>
                    { t('WC_REPORT_COLUMNS_GROUPING') }
                </h3>
                <div>
                    <ColumnGroupControlList
                        reportType={ reportType }
                        columns={ reportSettings.tableColumns }
                        onChange={ handleColumnsChanged }
                    />
                </div>
            </div>
            <div>
                <h3>
                    { t('WC_REPORT_COLUMNS_SORTING') }
                </h3>
                <div>
                    <ColumnSortControlList
                        reportType={ reportType }
                        columns={ reportSettings.tableColumns }
                        onChange={ handleColumnsChanged }
                    />
                </div>
            </div>
        </div>
        <div>
            <h3>
                { t('SERVER_CONFIG_CAMERA_PREVIEW') }
            </h3>
            <div>
                <TablePreview
                    reportType={ reportType }
                    columns={ reportSettings.tableColumns }
                />
            </div>
        </div>
    </Fragment>
;

type RecomposeProps = {
    handleColumnsChanged: (columns: ReadonlyArray<TableColumn>) => void;
};

export const TableLayoutSection = compose<Props, OwnProps>(
    setDisplayName('TableLayoutSection'),
    translate(),
    withHandlers<OwnProps, RecomposeProps>({
        handleColumnsChanged: ({ reportSettings, onChange }) => (columns: ReadonlyArray<TableColumn>) => {
            onChange(reportSettings => reportSettings.setTableColumns(columns));
        },
    }),
)(RawTableLayoutSection);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/tableLayout/TableLayoutSection.tsx